/**
 * @generated SignedSource<<66a2258d1c727b060fd4ba5014a4dc80>>
 * @relayHash 8ab18764e7c16c14216367e856dab0c3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 457ac47add6adbc0db836b0fa7db2101b18eca1437f536c81045456ccdce6549

import type { ConcreteRequest, Query } from 'relay-runtime';
export type FeedRecommendationQuery$variables = Record<PropertyKey, never>;
export type FeedRecommendationQuery$data = {
  readonly getRecommendedFeedUserConfig: {
    readonly recommendedPeople: ReadonlyArray<{
      readonly score: number;
      readonly user: {
        readonly displayName: string | null | undefined;
        readonly id: string | null | undefined;
        readonly isActive: boolean | null | undefined;
        readonly photos: ReadonlyArray<{
          readonly isPrimary: boolean | null | undefined;
          readonly value: string | null | undefined;
        } | null | undefined> | null | undefined;
        readonly title: string | null | undefined;
      } | null | undefined;
    }>;
    readonly recommendedSpaces: ReadonlyArray<{
      readonly score: number;
      readonly space: {
        readonly icon: {
          readonly path: string;
        } | null | undefined;
        readonly id: string | null | undefined;
        readonly key: string | null | undefined;
        readonly name: string | null | undefined;
      } | null | undefined;
    }>;
  } | null | undefined;
  readonly userPreferences: {
    readonly feedRecommendedUserSettingsDismissTimestamp: string;
  } | null | undefined;
};
export type FeedRecommendationQuery = {
  response: FeedRecommendationQuery$data;
  variables: FeedRecommendationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "score"
},
v1 = {
  "kind": "ScalarField",
  "name": "id"
},
v2 = [
  {
    "concreteType": "RecommendedFeedUserConfig",
    "kind": "LinkedField",
    "name": "getRecommendedFeedUserConfig",
    "plural": false,
    "selections": [
      {
        "concreteType": "RecommendedSpaceItem",
        "kind": "LinkedField",
        "name": "recommendedSpaces",
        "plural": true,
        "selections": [
          (v0/*: any*/),
          {
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "kind": "ScalarField",
                "name": "key"
              },
              {
                "kind": "ScalarField",
                "name": "name"
              },
              {
                "concreteType": "Icon",
                "kind": "LinkedField",
                "name": "icon",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "path"
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "concreteType": "RecommendedPeopleItem",
        "kind": "LinkedField",
        "name": "recommendedPeople",
        "plural": true,
        "selections": [
          (v0/*: any*/),
          {
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "kind": "ScalarField",
                "name": "title"
              },
              {
                "kind": "ScalarField",
                "name": "displayName"
              },
              {
                "kind": "ScalarField",
                "name": "isActive"
              },
              {
                "concreteType": "AtlassianUserPhoto",
                "kind": "LinkedField",
                "name": "photos",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "value"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "isPrimary"
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  {
    "concreteType": "UserPreferences",
    "kind": "LinkedField",
    "name": "userPreferences",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "feedRecommendedUserSettingsDismissTimestamp"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "FeedRecommendationQuery",
    "selections": (v2/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "FeedRecommendationQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "8ab18764e7c16c14216367e856dab0c3",
    "id": "457ac47add6adbc0db836b0fa7db2101b18eca1437f536c81045456ccdce6549",
    "metadata": {},
    "name": "FeedRecommendationQuery",
    "operationKind": "query",
    "text": "query FeedRecommendationQuery{getRecommendedFeedUserConfig{recommendedSpaces{score,space{id,key,name,icon{path}}},recommendedPeople{score,user{id,title,displayName,isActive,photos{value,isPrimary}}}},userPreferences{feedRecommendedUserSettingsDismissTimestamp}}"
  }
};
})();

(node as any).hash = "cd2b1cf86c5bfd971e4c48e39a4c5b14";

export default node;
